// ChatWindow.jsx
import React from "react";
import ChatLog from "../common/ChatLog";
import AssistantCard from "../common/AssistantCard";
import HintButtons from "../common/HintButtons";
import { useTranslation } from "react-i18next";

export default function ChatWindow({
  exploring,
  assistants,
  chooseAssistant,
  chatLog,
  chatLogRef,
  hints,
  setInput,
  handleSubmit,
}) {
  const { t } = useTranslation();

  return (
      <div className={`chat-log-container ${chatLog.length === 0 ? "center" : ""}`} ref={chatLogRef}>
        {exploring ? (
          <div className="assistant-cards-wrapper">
            <h2>{t('choose_an_assistant')}</h2>
            <div className="assistant-cards">
              {assistants.map((a) => (
                <AssistantCard key={a.assistantId} assistant={a} onClick={chooseAssistant} />
              ))}
            </div>
          </div>
        ) : chatLog.length === 0 ? (
          <HintButtons setInput={setInput} handleSubmit={handleSubmit} hints={hints} />
        ) : (
          <ChatLog chatLog={chatLog} />
        )}
      </div>
  );
}